import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import Tabination from "../../../reusableComponents/Tabination";
import EmailIcon from "../../../assets/icons/email.svg";
import CheckSolidGreenIcon from "../../../assets/icons/check-solid-green.svg";
import UserIcon from "../../../assets/icons/user.svg";
import PhoneIcon from "../../../assets/icons/phone.svg";
import ApartmentNoIcon from "../../../assets/icons/apartment-no.svg";
import StateIcon from "../../../assets/icons/state.svg";
import CountryIcon from "../../../assets/icons/country.svg";
import Warning from "../Verification/Warning";
import Close from "../../../assets/icons/circle-cross.svg";
import Select from "react-select";
import cross from "../../../assets/newIcons/crossCircleIcon.svg";
import ErrorModal from "../../../reusableComponents/ErrorModal";
// import SuccessModal from "../../reusableComponents/SuccessModal";
import SuccessModal from "../../../reusableComponents/SuccessModal";
import {returnMessages} from "../../../store/reducers/message";
import {returnErrors} from "../../../store/reducers/error";

import {addACH, addCrypto, addCtypto, addDeel, addPaypal, addSwift, addWire} from "../../../utils/apis/user";
import {useDispatch, useSelector} from "react-redux";
import {country} from "../../../utils/constants/country";
import {Checkbox, FormControlLabel, Modal} from "@mui/material";
import {validateEmail, validatePassword} from "../../../utils/helpers/string";
import customStyles, {newCryptoSelectorStyles, newSelectorStyles} from "../../../customstyle/customstyle";
import {paymentMethods} from "../../../utils/apis/payment";
import Spinner from "../../../reusableComponents/Spinner";

function RecipientBankDetails({closeBankDetailsModal, value, setValue, setRefreshBanksDetails, refreshBanksDetails}) {
  const bankName = ["", "Deel", "ACH", "Wire", "Swift", "Paypal", "USDT ERC-20", "USDT BEP-20"];
  const [defaultValue, setdefaultValue] = useState([]);
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  const fetchPaymentMethods = async (value) => {
    const response = await paymentMethods(idToken, dispatch);

    const banksDefault = Object.keys(response)?.map((item) => {
      const array = response[item];

      return {...array[0], name: item};
    });
    const newValue = value === 5 ? 1 : value;
    setdefaultValue(banksDefault);
    setInputValues(banksDefault[Number(newValue)]);
  };

  useEffect(() => {
    fetchPaymentMethods(value);
    setInputValues(defaultValue);
  }, [value]);

  const [inputValues, setInputValues] = useState({
    account_name: "",
    wallet: "",
    email: "",
    account_number: "",
    bic_code: "",
    account_type: "",
    mobile_number: "",
    username: "",
    routing_number: "",
    default: false,
    address: {
      country: "",
      state: "",
      city: "",
      apartment_no: "",
      street_address: "",
      zip_code: "",
      first_name: "",
      last_name: "",
    },
  });

  const handleSelectChange = (name, selectedOption) => {
    setInputValues((prev) => ({...prev, [name]: selectedOption}));
    // setInputValues((prev) => ({ ...prev }));
  };

  const banks = [
    {
      name: "dummy",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={true}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
          />
          {/* <Warning /> */}
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "Deel",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Warning /> */}
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "ACH",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={true}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "Wire",
      content: (
        <div className="form_container">
          {/* <Warning /> */}
          <RecipientAddress
            setInputValues={setInputValues}
            inputValues={inputValues}
            handleSelectChange={handleSelectChange}
          />
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={true}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "Swift",
      content: (
        <div className="form_container">
          {/* <Warning /> */}
          <RecipientAddress
            setInputValues={setInputValues}
            inputValues={inputValues}
            handleSelectChange={handleSelectChange}
          />
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={true}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "Paypal",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={false}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "USDT BEP-20",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={false}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
    {
      name: "USDT ERC-20",
      content: (
        <div className="form_container">
          <GeneralInfo
            refreshBanksDetails={refreshBanksDetails}
            setRefreshBanksDetails={setRefreshBanksDetails}
            email={false}
            setInputValues={setInputValues}
            inputValues={inputValues}
            value={value}
            closeBankDetailsModal={closeBankDetailsModal}
            defaultValue={defaultValue}
            fetchPaymentMethods={fetchPaymentMethods}
          />
          {/* <Button /> */}
        </div>
      ),
    },
  ];
  let items = [];
  if (value) {
    if (banks.name === "dummmy") {
    } else {
      items.push(banks[value]);
    }
  }
  const handleClose = () => {
    setValue(false);
  };

  useEffect(() => {
    const contentWrapper = document.querySelector(".contentWrapper");

    if (contentWrapper) {
      if (value) {
        // Scroll to the top first
        contentWrapper.scrollTo({
          top: 0,
          behavior: "smooth", // Smooth scrolling for better UX
        });
        // Then set overflow to hidden
        contentWrapper.style.overflow = "hidden";
      } else {
        // Restore overflow to auto when value is false
        contentWrapper.style.overflow = "auto";
      }
    }
  }, [value]);

  return (
    value && (
      <div
        className="bankdetails_modal_overlay"
        open={value}
      >
        <div className={`bankdetails_modal_container ${value === 6 || value === 7 ? "usdtModal" : ""}`}>
          <div className="modal_header">
            <p>{bankName[value]} Details</p>

            {/* ------------cross icon
            <div
              className="crossIcon"
              style={{cursor: "pointer"}}
            >
              <img
                src={cross}
                alt=""
                onClick={() => setValue(null)}
              />
            </div> */}
          </div>
          <div className="formSection">
            <Tabination
              variant={3}
              tabItems={items}
              activeTab={0}
              showTabs={false}
            />
          </div>
        </div>
      </div>
    )
  );
}

export default RecipientBankDetails;

const GeneralInfo = ({email, setInputValues, inputValues, value, closeBankDetailsModal, defaultValue, fetchPaymentMethods, refreshBanksDetails, setRefreshBanksDetails}) => {
  const idToken = useSelector((state) => state.auth.idToken);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isErrorModal, setErrorModal] = useState(false);
  const [isInputError, setIsInputError] = useState({
    email: false,
    password: false,
  });
  const [isModal, setModal] = useState(null);

  let emailRef = useRef(null);
  let passwordRef = useRef(null);

  console.log("valueb", value);

  // submit

  // const handleBlur = (e) => {
  //   const {id} = e.target;
  //   id === "email" && emailRef.current.classList.remove("input-error");
  //   id === "password" && passwordRef.current.classList.remove("input-error");
  // };
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleFocus = (e) => {
    const {id} = e.target;
    setIsInputError((prev) => ({...prev, [id]: false}));
  };
  const [isSpinner, setIsSpinner] = useState(false);
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    // Validation for specific API call
    let isValid = true;
    switch (value) {
      case 3: // Wire API
        if (
          !inputValues?.bic_code ||
          !inputValues?.iban_number ||
          !inputValues?.address.country ||
          !inputValues?.address.state ||
          !inputValues?.address.city ||
          !inputValues?.address.apartment_no ||
          !inputValues?.address.street_address ||
          !inputValues?.address.zip_code ||
          !inputValues?.address.first_name ||
          !inputValues?.address.last_name
        ) {
          dispatch(returnErrors("Please fill all the fields", 400));
          isValid = false;
        }
        break;
      case 5: // Paypal API
        if (!inputValues?.username || !inputValues?.email || !inputValues?.mobile_number) {
          dispatch(returnErrors("Please fill all required fields for Paypal", 400));
          isValid = false;
        }
        break;
      case 6: // Crypto API
        if (!inputValues?.wallet.trim()) {
          dispatch(returnErrors("wallet address is compulsory for payout", 400));
          isValid = false;
        }
      case 7: // Crypto API
        if (!inputValues?.wallet.trim()) {
          dispatch(returnErrors("wallet address is compulsory for payout", 400));
          isValid = false;
        }
        break;
      default:
        break;
    }

    if (!isValid) {
      return;
    }

    // Construct objects for API call
    const paypal = {
      username: inputValues?.username,
      email: inputValues?.email,
      mobile_number: inputValues?.mobile_number,
    };
    const crypto = {
      wallet: inputValues?.wallet,
      // crypto_type: value === 6 ? "USDT ERC-20" : value === 7 ? "USDT BEP-20" : "",
    };
    const wire = {
      bic_code: inputValues?.bic_code,
      iban_number: inputValues?.iban_number,
      address: {
        country: inputValues?.address?.country,
        state: inputValues?.address?.state,
        city: inputValues?.address?.city,
        apartment_no: inputValues?.address?.apartment_no,
        street_address: inputValues?.address?.street_address,
        zip_code: inputValues?.address?.zip_code,
        first_name: inputValues?.address?.first_name,
        last_name: inputValues?.address?.last_name,
      },
    };

    // Proceed with API call based on the selected option
    try {
      setIsSpinner(true);
      let res;
      switch (value) {
        case 3: // Wire API
          if (!checked) {
            dispatch(returnErrors("Please acknowledge the provided information", 500));
            setIsSpinner(false);
            return;
          }
          res = await addWire(idToken, wire);
          break;
        case 5: // Paypal API
          res = await addPaypal(idToken, paypal);
          break;
        case 6: // Crypto API
          res = await addCrypto(idToken, crypto);
          break;
        case 7: // Crypto API
          res = await addCrypto(idToken, crypto);
          break;
        default:
          break;
      }

      // Handle API response
      if (res.status < 203) {
        setIsSpinner(false);
        // dispatch(returnMessages("Successfully updated", 200));
        setRefreshBanksDetails(!refreshBanksDetails);
        closeBankDetailsModal();
      } else if (res.response?.status >= 399) {
        setIsSpinner(false);
        // Handle error response
        const error = res.response.data;
        let msg;
        if (Object.keys(error).length > 0) {
          const firstKey = Object.keys(error)[0];
          if (firstKey === "address") {
            const subError = error[firstKey];
            if (Object.keys(subError).length > 0) {
              const firstKey1 = Object.keys(subError)[0];

              // const firstString = subError[firstKey1] || subError[firstKey1][0];
              msg = firstKey1;
            }
          } else {
            const firstString = error[firstKey] || error[firstKey][0];

            msg = firstKey;
          }
        } else {
          msg = "Something went wrong";
        }
        const newmsg = `${msg?.replace(/_/g, " ") + " field be required"}`;
        dispatch(returnErrors(newmsg, 500));
      }
    } catch (error) {
      setIsSpinner(false);

      dispatch(returnErrors("An error occurred", 500));
    }
  };

  return (
    <>
      <div className="formBottomSection">
        <div className="general_info_form_wrapper">
          <div className="general_info_form_container">
            <div className="general_info_form">
              {/* name */}
              {email === true && !value === 3 ? (
                <div className="general_info_form_input_container">
                  <div className="general_info_input">
                    <label
                      className="general_info_label"
                      htmlFor="name"
                    >
                      Account Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      autoComplete="new-password"
                      placeholder="Account Name"
                      value={inputValues?.account_name}
                      onChange={(e) => setInputValues({...inputValues, account_name: e.target.value})}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              {value === 6 && (
                <>
                  <div>
                    <label htmlFor="contact">Wallet Address (USDT ERC-20)</label>
                    <div className="general_info_form_input_container">
                      <div className="general_info_input">
                        <input
                          type="text"
                          name="USDT ERC-20"
                          id="USDT ERC-20"
                          autoComplete="new-password"
                          placeholder="USDT ERC-20"
                          value={inputValues?.wallet}
                          onChange={(e) => setInputValues({...inputValues, wallet: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {value === 7 && (
                <>
                  <div>
                    <label htmlFor="contact">Wallet Address (USDT BEP-20)</label>
                    <div className="general_info_form_input_container">
                      <div className="general_info_input">
                        <input
                          type="text"
                          name="USDT BEP-20"
                          id="USDT BEP-20"
                          autoComplete="new-password"
                          placeholder="USDT BEP-20"
                          value={inputValues?.wallet}
                          onChange={(e) => setInputValues({...inputValues, wallet: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {value === 5 && (
                <div className="general_info_form_input_container">
                  <div className="general_info_input">
                    <label
                      className="general_info_label"
                      htmlFor="name"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      autoComplete="new-password"
                      placeholder="Name"
                      value={inputValues?.username}
                      onChange={(e) => setInputValues({...inputValues, username: e.target.value})}
                    />
                  </div>
                </div>
              )}

              {/* email */}

              {value === 5 && (
                <div className="general_info_form_input_container">
                  <div className="general_info_input">
                    <label
                      className="general_info_label"
                      htmlFor="email"
                    >
                      Email Address
                    </label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      autoComplete="new-password"
                      placeholder="Email Address"
                      value={inputValues?.email}
                      onChange={(e) => setInputValues({...inputValues, email: e.target.value})}
                      // onBlur={handleBlur}
                      onFocus={handleFocus}
                    />
                  </div>
                  <div className="signinform-container_icon">
                    {validateEmail(inputValues?.email) && (
                      <img
                        src={CheckSolidGreenIcon}
                        alt=""
                        className="signinform-icon"
                      />
                    )}
                  </div>
                </div>
              )}
              {value === 1 || value === 2 || value === 4 ? (
                <div className="account_type">
                  <p>Default type</p>
                  <div className="radio_container">
                    <div>
                      <input
                        type="radio"
                        name="account_type"
                        autoComplete="new-password"
                        value={true}
                        // checked={inputValues?.default === false ? true : ""}
                        onChange={(e) => setInputValues({...inputValues, default: e.target.value})}
                      />
                      <label>Yes </label>
                    </div>

                    <div>
                      <input
                        type="radio"
                        name="account_type"
                        autoComplete="new-password"
                        value={false}
                        // checked={inputValues?.default === false}
                        onChange={(e) => setInputValues({...inputValues, default: e.target.value})}
                      />
                      <label>No</label>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {value === 2 || value === 4 ? (
                <>
                  <div className="general_info_form_input_container">
                    <div className="general_info_input">
                      <label
                        className="general_info_label"
                        htmlFor="name"
                      >
                        Routing Number
                      </label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        autoComplete="new-password"
                        placeholder="Routing Number"
                        value={inputValues?.routing_number}
                        onChange={(e) => setInputValues({...inputValues, routing_number: e.target.value})}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {/* contact */}
              {email === true ? (
                <>
                  {email === true && !value === 3 && (
                    <div>
                      <label
                        // className="general_info_label"
                        htmlFor="contact"
                      >
                        Account Number
                      </label>
                      <div className="general_info_form_input_container">
                        <div className="general_info_input">
                          <input
                            type="number"
                            name="contact"
                            id="contact"
                            autoComplete="new-password"
                            placeholder="Account Number"
                            value={inputValues?.account_number}
                            onChange={(e) => setInputValues({...inputValues, account_number: e.target.value})}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <label
                      // className="general_info_label"
                      htmlFor="contact"
                    >
                      IBAN Number
                    </label>
                    <div className="general_info_form_input_container">
                      <div className="general_info_input">
                        <input
                          type="text"
                          name="contact"
                          id="contact"
                          autoComplete="new-password"
                          placeholder="IBAN Number"
                          value={inputValues?.iban_number}
                          onChange={(e) => setInputValues({...inputValues, iban_number: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label
                      // className="general_info_label"
                      htmlFor="contact"
                    >
                      BIC Code
                    </label>
                    <div className="general_info_form_input_container">
                      <div className="general_info_input">
                        <input
                          type="text"
                          name="contact"
                          id="contact"
                          autoComplete="new-password"
                          placeholder="Bic code"
                          value={inputValues?.bic_code}
                          onChange={(e) => setInputValues({...inputValues, bic_code: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {value === 5 ? (
                <div className="general_info_form_input_container">
                  <div className="general_info_input">
                    <label
                      className="general_info_label"
                      htmlFor="contact"
                    >
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="contact"
                      id="contact"
                      autoComplete="new-password"
                      placeholder="Contact Number"
                      value={inputValues?.mobile_number}
                      onChange={(e) => setInputValues({...inputValues, mobile_number: e.target.value})}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {value === 3 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                  />
                }
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "#fff", // Default color
                    borderRadius: "11px",
                  },
                  "&.Mui-checked": {
                    backgroundColor: "#36D66B", // Background color when checked
                  },
                }}
                label={<div className="acknowledgeText">I hereby acknowledge that the above information is correct</div>}
              />
            )}

            {isModalOpen && (
              <SuccessModal
                setModalOpen={closeBankDetailsModal}
                title="Case Created"
                desc={isModal?.message}
                btnText="Close"
                modal={closeBankDetailsModal}
              />
            )}
            {isErrorModal && (
              <ErrorModal
                setModalOpen={setErrorModal}
                title="Something Error"
                desc={isModal?.message}
                btnText="Close"
              />
            )}
          </div>
        </div>
      </div>
      <Button
        handleSubmit={handleSubmit}
        isSpinner={isSpinner}
        value={value}
        dispatch={dispatch}
        wallet={inputValues?.wallet}
        closeBankDetailsModal={closeBankDetailsModal}
      />
    </>
  );
};

export const Button = ({handleSubmit, isSpinner, value, wallet, dispatch, closeBankDetailsModal}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const onNext = () => {
    if (!wallet?.trim() && (value === 6 || value === 7)) {
      dispatch(returnErrors("wallet address is compulsory for payout", 400));
      return;
    }
    if (value === 6 || value === 7) {
      setShowConfirm(true);
    } else {
      handleSubmit();
    }
  };

  return (
    <>
      <div className="btn_container2 modal_resp">
        <button
          className="back_info_btn"
          onClick={() => {
            if (typeof closeBankDetailsModal === "function") closeBankDetailsModal(true);
          }}
        >
          Back
        </button>
        <button
          className="save_info_btn"
          onClick={onNext}
        >
          {isSpinner ? <Spinner /> : "Next"}
        </button>
      </div>

      <Modal
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        className="bankdetails_modal_overlay"
      >
        <div className="bankdetails_modal_container usdtModal">
          <div className="modal_header">
            <p>The {value === 7 ? "USDT BEP-20" : value === 6 ? "USDT ERC-20" : "USDT"} Wallet Address you have provided is: </p>
          </div>
          <p className="modal_value_text">{wallet || "—"}</p>
          <p className="warningtext">
            Please ensure you have provided your correct {value === 7 ? "USDT BEP-20" : value === 6 ? "USDT ERC-20" : "USDT"} wallet address. Providing incorrect details will result in your funds
            becoming irrecoverable and Equity Edge will not accept any liability for this.
          </p>
          <div className="btn_container2 modal_resp">
            <button
              onClick={() => setShowConfirm(false)}
              className="back_info_btn"
            >
              Back
            </button>
            <button
              onClick={async () => {
                setShowConfirm(false);
                await handleSubmit();
              }}
              disabled={isSpinner}
              className="save_info_btn"
            >
              {isSpinner ? <Spinner /> : "Accept"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

const RecipientAddress = ({inputValues, setInputValues, handleSelectChange}) => {
  const stateOptions = [{value: "ca", label: "California"}];
  const countryOptions = [{value: "ca", label: "Canada"}];
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  return (
    <div className="recipient_info_form_container">
      {/* <p>Recipients Address</p> */}
      <div className="recipient_info_form">
        <div className="recipient_info_form_input_container">
          <div className=" recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="country"
            >
              Country
            </label>
            <Select
              styles={selectedBrand?.brand === "equity_edge" ? newSelectorStyles(50) : selectedBrand?.brand === "crypto_edge" ? newCryptoSelectorStyles(50) : newSelectorStyles(50)}
              options={country?.map((item) => ({
                ...item,
                value: `${item?.country}`,
                label: `${item?.country}`,
              }))}
              className="react_select_container"
              classNamePrefix="react-select"
              name="country"
              placeholder="Country"
              value={{label: inputValues?.address?.country, value: inputValues?.address?.country}}
              onChange={(selectedOption) =>
                handleSelectChange(
                  "country",
                  setInputValues((prevValues) => ({
                    ...prevValues,
                    address: {
                      ...prevValues.address,
                      country: selectedOption.label,
                    },
                  })),
                )
              }
            />
          </div>
        </div>

        <div className="recipient_info_form_input_container">
          <div className=" recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="state"
            >
              First Name
            </label>
            <input
              type="text"
              name="first_name"
              id="first_name"
              autoComplete="new-password"
              placeholder="First Name"
              value={inputValues?.address?.first_name}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    first_name: e?.target?.value,
                  },
                })
              }
            />
          </div>
        </div>
        <div className="recipient_info_form_input_container">
          <div className=" recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="state"
            >
              Last Name
            </label>
            <input
              type="text"
              name="last_name"
              id="last_name"
              placeholder="Last Name"
              autoComplete="new-password"
              value={inputValues?.address?.last_name}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    last_name: e?.target?.value,
                  },
                })
              }
            />
          </div>
        </div>
        <div className="recipient_info_form_input_container">
          <div className=" recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="state"
            >
              State
            </label>
            <input
              type="text"
              name="apartmentNo"
              id="apartmentNo"
              placeholder="State"
              autoComplete="new-password"
              value={inputValues?.address?.state}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    state: e?.target?.value,
                  },
                })
              }
            />
          </div>
        </div>

        <div className="recipient_info_form_input_container">
          <div className="form_input recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="aprtmentNo"
            >
              Apartment No
            </label>
            <input
              type="text"
              name="apartmentNo"
              id="apartmentNo"
              autoComplete="new-password"
              placeholder="Apartment No"
              value={inputValues?.address?.apartment_no}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    apartment_no: e?.target?.value,
                  },
                })
              }
            />
          </div>
        </div>

        <div className="recipient_info_form_input_container">
          <div className="form_input recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="aprtmentNo"
            >
              City
            </label>
            <input
              type="text"
              name="apartmentNo"
              id="apartmentNo"
              placeholder="City"
              autoComplete="new-password"
              value={inputValues?.address?.city}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    city: e.target?.value,
                  },
                })
              }
            />
          </div>
        </div>

        <div className="recipient_info_form_input_container">
          <div className="form_input recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="aprtmentNo"
            >
              Street Address
            </label>
            <input
              type="text"
              name="apartmentNo"
              id="apartmentNo"
              placeholder="Street Address"
              autoComplete="new-password"
              value={inputValues?.address?.street_address}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    street_address: e.target.value,
                  },
                })
              }
            />
          </div>
        </div>

        <div className="recipient_info_form_input_container">
          <div className="form_input recipient_info_input">
            <label
              className="general_info_label"
              htmlFor="aprtmentNo"
            >
              Zip Code
            </label>
            <input
              type="text"
              name="apartmentNo"
              id="apartmentNo"
              placeholder="Zip Code"
              autoComplete="new-password"
              value={inputValues?.address?.zip_code}
              onChange={(e) =>
                setInputValues({
                  ...inputValues,
                  address: {
                    ...inputValues?.address,
                    zip_code: e.target.value,
                  },
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
